import { en, pt } from './locales';

import './meetingRooms/style.scss';
import './parking/style.scss';

import meetingRoomsReducer from './meetingRooms/reducers';
import { meetingRoomsSagas } from './meetingRooms/sagas';
import buildingsReducer from "./buildings/reducers";
import {buildingsSagas} from "./buildings/sagas";
import visitsReducer from "./visits/reducers";
import {visitsSagas} from "./visits/sagas";
import visitorsReducer from "./visitors/reducers";
import {visitorsSagas} from "./visitors/sagas";
import consoleUsersReducer from './consoleUsers/reducers';
import {consoleUsersSagas} from "./consoleUsers/sagas";
import parkingReducer from './parking/reducers';
import {parkingSagas} from './parking/sagas';

const rootReducer = {
    meetingRoomsReducer: meetingRoomsReducer,
    buildingsReducer: buildingsReducer,
    visitsReducer: visitsReducer,
    visitorsReducer: visitorsReducer,
    consoleUsersReducer: consoleUsersReducer,
    parkingReducer: parkingReducer
};

const sagas = [
    ...meetingRoomsSagas,
    ...buildingsSagas,
    ...visitsSagas,
    ...visitorsSagas,
    ...consoleUsersSagas,
    ...parkingSagas
];

const locales = {
    'en': en,
    'pt': pt,
};

export {
    rootReducer,
    sagas,
    locales,
}